/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type UnarchiveUserInput = {
    userId: string;
    clientMutationId?: string | null | undefined;
};
export type UserListRowUnarchiveUserMutationVariables = {
    input: UnarchiveUserInput;
};
export type UserListRowUnarchiveUserMutationResponse = {
    readonly unarchiveUser: {
        readonly clientMutationId: string | null;
        readonly user: {
            readonly __typename: string;
            readonly archived: boolean | null;
            readonly id: string;
        };
    } | null;
};
export type UserListRowUnarchiveUserMutation = {
    readonly response: UserListRowUnarchiveUserMutationResponse;
    readonly variables: UserListRowUnarchiveUserMutationVariables;
};



/*
mutation UserListRowUnarchiveUserMutation(
  $input: UnarchiveUserInput!
) {
  unarchiveUser(input: $input) {
    clientMutationId
    user {
      __typename
      archived
      id
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UnarchiveUserPayload",
    "kind": "LinkedField",
    "name": "unarchiveUser",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "archived",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UserListRowUnarchiveUserMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UserListRowUnarchiveUserMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "aa66358a51dcdc71afe51873cf4200b0",
    "id": null,
    "metadata": {},
    "name": "UserListRowUnarchiveUserMutation",
    "operationKind": "mutation",
    "text": "mutation UserListRowUnarchiveUserMutation(\n  $input: UnarchiveUserInput!\n) {\n  unarchiveUser(input: $input) {\n    clientMutationId\n    user {\n      __typename\n      archived\n      id\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = '82b8e441e84189b0826e648cfcbba930';
export default node;
